import { Flex, xcss } from '@atlaskit/primitives';
import { Stripe } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = xcss({
  marginTop: 'space.100'
});
export const AccordionLoading = _ref => {
  let {
    testId
  } = _ref;
  return /*#__PURE__*/_jsxs(Flex, {
    direction: "column",
    gap: "space.150",
    xcss: styles,
    testId: testId,
    children: [/*#__PURE__*/_jsx(Stripe, {
      width: "6.25rem",
      height: "0.6rem"
    }), /*#__PURE__*/_jsx(Stripe, {
      height: "3.2rem"
    })]
  });
};